import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/movimentacao-conta/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findMovimentacaoConta({
  empresa_cnpj,
  include,
  id,
  where = {},
  wherein = {},
  page,
  perPage = "50",
  fields,
  orWhere,
  whereNull = [],
}) {
  let queryOrWhere = "";
  if (orWhere) {
    Object.keys(orWhere).forEach((key) => {
      queryOrWhere += `&orwhere[${key}]=${orWhere[key]}`;
    });
  }

  let query = "";
  Object.keys(where).forEach((value) => {
    query += `&where[${value}]=${where[value]}`;
  });

  let queryWhereIn = "";
  Object.keys(wherein).forEach((row) => {
    queryWhereIn += `&wherein[${row}]=${wherein[row]}`;
  });

  let querywhereNull = "";
  whereNull?.forEach((field) => {
    querywhereNull += `&whereNull[${field}]`;
  });

  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }${query ?? ""}${queryOrWhere}${queryWhereIn ?? ""}${querywhereNull}${
      page ? `&page=${page}` : ""
    }${perPage ? `&per_page=${perPage}` : ""}${fields ? `&${fields}` : ""}`,
    "GET",
    headers
  );
}

export async function createMovimentacaoConta({ empresa_cnpj, body }) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}
